import { render } from "./practice-investigation-details.html?vue&type=template&id=3eb415c0&scoped=true&ts=true&external"
import script from "./practice-investigation-details.ts?vue&type=script&lang=ts&external"
export * from "./practice-investigation-details.ts?vue&type=script&lang=ts&external"

import "./practice-investigation-details.scss?vue&type=style&index=0&id=3eb415c0&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eb415c0"]])

export default __exports__